import PropTypes from "prop-types";
import React from "react";
import { Field } from "formik";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import ReactCountryFlag from "react-country-flag";

// Material
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

// Config
import styles from "../../config/styles";

// Components
import FormikAutocomplete from "../FormikAutocomplete";
import Text from "../Text";

const useStyles = makeStyles(theme => ({
  phone: {
    minWidth: 148,
    position: "relative",
    height: 48,
    marginRight: theme.spacing(1.5)
  },
  flag: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    left: theme.spacing(2),
    fontSize: "18px !important"
  },
  optionText: {
    fontSize: 15
  },
  optionFlag: {
    marginRight: theme.spacing(1)
  },
  phoneTextField: {
    border: styles.values.border,
    borderRadius: theme.shape.borderRadius,
    height: 48,
    display: "flex",
    justifyContent: "center"
  },
  phoneInput: {
    paddingLeft: theme.spacing(4),
    fontWeight: theme.typography.fontWeightMedium
  },
  listbox: {
    "&::-webkit-scrollbar": {
      width: 0
    }
  }
}));

const countriesList = getCountries();

const CountryField = ({ selectedCountryCode, ...rest }) => {
  const classes = useStyles();

  return (
    <Field
      classes={{
        listbox: classes.listbox
      }}
      className={classes.phone}
      component={FormikAutocomplete}
      disableClearable
      getOptionLabel={option => `${option} +${getCountryCallingCode(option)}`}
      name="country"
      options={countriesList}
      textFieldProps={{
        fullWidth: true,
        className: classes.phoneTextField,
        InputProps: {
          classes: { root: classes.phoneInput },
          startAdornment: (
            <InputAdornment position="start">
              <ReactCountryFlag
                className={classes.flag}
                countryCode={selectedCountryCode}
              />
            </InputAdornment>
          )
        }
      }}
      icon={
        <ReactCountryFlag
          className={classes.flag}
          countryCode={selectedCountryCode}
        />
      }
      renderOption={option => (
        <Text type="body" className={classes.optionText}>
          <ReactCountryFlag
            className={classes.optionFlag}
            countryCode={option}
          />
          {`(${option}) +${getCountryCallingCode(option)}`}
        </Text>
      )}
      {...rest}
    />
  );
};

CountryField.propTypes = {
  selectedCountryCode: PropTypes.string.isRequired
};

export default CountryField;
